import { render, staticRenderFns } from "./QuotationStepInsured.vue?vue&type=template&id=5e79cdb8"
import script from "./QuotationStepInsured.vue?vue&type=script&lang=js"
export * from "./QuotationStepInsured.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepInsured.vue?vue&type=style&index=0&id=5e79cdb8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports